// Bryntum popups (task editor) use z-index up to 99999.
export const OVER_BOARD_Z = {
  modal: 100001, // Dialog, Menu, Popover, Select menus, Autocomplete, date pickers
  tooltip: 100002, // Tooltips inside an over-board dialog
  snackbar: 100003, // Notifications (always above everything)
};

// Use as <ThemeProvider theme={raiseAboveBoard}> — MUI merges with the outer theme.
// Theme context passes through portals, so menus, poppers and tooltips opened
// inside the subtree read the raised values too. Never applied app-wide.
export const raiseAboveBoard = (outer) => ({
  ...outer,
  zIndex: { ...outer.zIndex, ...OVER_BOARD_Z },
});
